import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchAllComments = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.comments
        .fetchAllComments(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_COMMENTS_FAILED,
              reject: actionTypes.GET_COMMENTS_REJECT
            })
          );
          // throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_COMMENTS_LOADING);
  const success = res => action(actionTypes.GET_COMMENTS_SUCCESS, res);
  return request();
};

export const initCommentsList = () => {
  return action(actionTypes.INIT_COMMENTS_LIST);
};

export const initUserCommentsList = () => {
  return action(actionTypes.INIT_USER_COMMENTS_LIST);
};

export const fetchAllUserComments = (userId, query) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.comments
        .fetchAllUserComments(userId, query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_USER_COMMENTS_FAILED,
              reject: actionTypes.FETCH_USER_COMMENTS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_USER_COMMENTS_LOADING);
  const success = res => action(actionTypes.FETCH_USER_COMMENTS_SUCCESS, res);
  return request();
};

export const replyToCustomerComment = (id, message) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.comments
        .replyToCustomerComment(id, message)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.REPLY_TO_CUSTOMER_COMMENT_FAILED,
              reject: actionTypes.REPLY_TO_CUSTOMER_COMMENT_REJECT
            })
          );

          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.REPLY_TO_CUSTOMER_COMMENT_LOADING);
  const success = res => action(actionTypes.REPLY_TO_CUSTOMER_COMMENT_SUCCESS, res);
  return request();
};

export const clearReplyToCustomerComment = () => {
  return action(actionTypes.CLEAR_REPLY_TO_CUSTOMER_COMMENT);
};

export const clearEditResponseComment = () => {
  return action(actionTypes.CLEAR_EDIT_RESPONSE_COMMENT_FORM);
};

export const updateCommentStatus = (id, status) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.comments
        .updateCommentStatus(id, status)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.UPDATE_COMMENT_STATUS_FAILED,
              reject: actionTypes.UPDATE_COMMENT_STATUS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.UPDATE_COMMENT_STATUS_LOADING);
  const success = res => action(actionTypes.UPDATE_COMMENT_STATUS_SUCCESS, { id, status, ...res });
  return request();
};

export const savePrevCommentsList = prevCommentsList => {
  return dispatch => dispatch(action(actionTypes.SAVE_PREV_COMMENTS_LIST, prevCommentsList));
};

export const saveUserPrevCommentsList = userPrevCommentsList => {
  return dispatch => dispatch(action(actionTypes.SAVE_PREV_USER_COMMENTS_LIST, userPrevCommentsList));
};

export const editResponse = (id, message) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.comments
        .editResponse(id, message)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.EDIT_RESPONSE_COMMENT_FAILED,
              reject: actionTypes.EDIT_RESPONSE_COMMENT_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.EDIT_RESPONSE_COMMENT_LOADING);
  const success = res => action(actionTypes.EDIT_RESPONSE_COMMENT_SUCCESS, res);
  return request();
};

export const changeCafeAccessStatusToResponse = (id, access) => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.comments
        .changeCafeAccessStatusToResponse(id, access)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CHANGE_CAFE_ACCESS_TO_RESPONSE_FAILED,
              reject: actionTypes.CHANGE_CAFE_ACCESS_TO_RESPONSE_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CHANGE_CAFE_ACCESS_TO_RESPONSE_LOADING);
  const success = res => action(actionTypes.CHANGE_CAFE_ACCESS_TO_RESPONSE_SUCCESS, { id, access, ...res });
  return request();
};
